"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalEventBus = void 0;
const tiny_emitter_1 = require("tiny-emitter");
if (!window.globalEventBus) {
    window.globalEventBus = new tiny_emitter_1.TinyEmitter();
}
class GlobalEventBus {
    static on(event, callback) {
        window.globalEventBus.on(event, callback);
    }
    static once(event, callback) {
        window.globalEventBus.once(event, callback);
    }
    static off(event, callback) {
        window.globalEventBus.off(event, callback);
    }
    static emit(event, ...args) {
        window.globalEventBus.emit(event, ...args);
    }
}
exports.GlobalEventBus = GlobalEventBus;
